<template>
  <div class="loading_full">
    <div class="lds-dual-ring"></div>
  </div>
</template>
<style scoped>
/* Absolute Center Spinner */
.loading_full {
  position: fixed;
  z-index: 1999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading_full:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    rgba(227, 227, 227, 0.8),
    rgba(227, 227, 227, 0.8)
  );

  background: -webkit-radial-gradient(
    rgba(243, 251, 255, 0.8),
    rgba(227, 227, 227, 0.8)
  );
}

/* :not(:required) hides these rules from IE9 and below */
.loading_full:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.lds-dual-ring,
.lds-dual-ring:after {
  box-sizing: border-box;
}
.lds-dual-ring {
  display: inline-block;
  width: 60px;
  height: 60px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 44px;
  height: 44px;
  margin: 4px;
  border-radius: 50%;
  border: 4.4px solid currentColor;
  border-color: #f08902 transparent #f08902 transparent;
  animation: lds-dual-ring 0.8s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
